<template>
  <furniture-card-mobile v-if="isMobile"
                         :min="min"
                         :max="max"
                         :icon="furniture.icon"
                         :value="furniture.quantity"
                         :label="furnitureName"
                         :step="furnitureStep"
                         :disassemble="disassembly"
                         :can-disassemble="displayDisassemble"
                         @input="onNumberChange"
                         @update:disassembly="updateDisassembly"
  />
  <div  v-else class="furniture-card">
      <card-counter
        :min="min"
        :max="max"
        :icon="furniture.icon"
        :value="furniture.quantity"
        :label="furnitureName"
        :step="furnitureStep"
        @input="onNumberChange"
      />
      <div v-if="displayDisassemble" class="furniture-card__checkbox">
        <el-checkbox v-model="disassembly"
                     :label="$t('inventory.furnitures.disassembly')"
        />
      </div>
    </div>
</template>
<script>
import CardCounter from './CardCounter.vue';
import FurnitureCardMobile from './FurnitureCardMobile.vue';

export default {
  name: 'furniture-card',

  components: { FurnitureCardMobile, CardCounter },
  props: {
    furniture: {
      type: Object,
      required: true,
    },
    min: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
    showDisassemble: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    style() {
      if (this.width) {
        return { width: `${this.width}px` };
      }
      return {};
    },
    displayDisassemble() {
      return this.showDisassemble && this.furniture.is_demontable;
    },
    disassembly: {
      get() {
        return this.furniture.demontage;
      },
      set(value) {
        this.$emit('update:disassembly', value);
      },
    },
    isMobile() {
      return this.$store.getters['dimensionStore/isMobile'];
    },
    furnitureName() {
      return this.furniture.name || this.furniture.nom_type || '';
    },
    isActive() {
      return this.furniture.quantity > 0;
    },
    furnitureStep() {
      return Math.round(parseFloat(this.furniture.quantite_type));
    },
  },
  methods: {
    onNumberChange(qty) {
      if (qty >= this.min && qty <= this.max) this.$emit('update:quantity', qty);
    },
    updateDisassembly(value) {
      this.disassembly = value;
    },
  },
};
</script>

<style src="@/assets/scss/furnitures.scss" lang="scss" scoped/>
<style scoped lang="scss">
  .furniture-card{
    width: 150px;

    @include breakpoint(wide){
      width: 250px;
    }

    &__checkbox {
      user-select: none;
      font-size: 10px;
      margin: .3em;
    }
  }
</style>
